import React, { useEffect, useState } from 'react';
import Pagination from '../../../molecules/Pagination';
import { PaginationBox } from '../../ExamInfoPageElements/PassNote/style';
import { Line, TabTitle } from '../Lectures/style';
import {
  QuestionContainer,
  QuestionContent,
  QuestionTable,
  ButtonContainer,
  DataNotFound,
} from './style';
import { ReactComponent as PrevBtn } from '../../../../assets/icons/icon-PrevBtnFull.svg';
import { ReactComponent as NextBtn } from '../../../../assets/icons/icon-NextBtnFull.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Filter from '../../../molecules/Filter';
import Search from '../../../molecules/Search';
import { ButtonBox } from '../Review/style';
import { Button } from '../../../atoms/Button/index';

import QuestionDetailPage from '../../../../pages/QuestionDetail/QuestionDetailPage';

import { SpinLoader, typeList } from '../../../atoms/SpinLoader';
import { useChangeMonthNumToEn } from '../../../../hooks/useChangeMonthNumToEn';
import { useRecoilValue, useRecoilState } from 'recoil';
import {
  professorQuestionPageInfoAtom,
  professorQuestionListAtom,
} from '../../../../recoil/ProfessorStore/ProfessorRecoil';
import { selectedProfessorQuestionFilterMenuAtom } from '../../../../recoil/SelectedFilterStore/SelectedFilterRecoil';

import { useQuery } from 'react-query';
import useHandleError from '../../../../hooks/useHandleError';
import { getProfessorQnaPageInfo, getProfessorQnaList } from '../../../../axiosManage/Professor';

import { isLoginAtom } from '../../../../recoil/AuthStore/AuthRecoil';

const FILTER_MENU = [
  {
    id: 0,
    category: '강의',
  },
  {
    id: 1,
    category: '교재',
  },
  {
    id: 2,
    category: '커리큘럼',
  },
  {
    id: 3,
    category: '기타',
  },
];

const Question = ({ professorId }) => {
  const isLogin = useRecoilValue(isLoginAtom);
  const { handleError } = useHandleError();
  const { id } = useParams();
  const navigate = useNavigate();

  /** url을 통한 교수 ID 설정 */
  const [ProfessorId, setProfessorId] = useState(1);
  useEffect(() => {
    setProfessorId(professorId);
  }, [professorId]);

  /* 페이지네이션 */
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(6);

  const clickPrevBtn = (e) => {
    setCurrentPage(currentPage - 1);
  };
  const clickNextBtn = (e) => {
    setCurrentPage(currentPage + 1);
  };

  /** 필터링 & 검색 기능 */
  const [keyword, setKeyword] = useState('');
  const [isSearchBtnClicked, setIsSearchBtnClicked] = useState(false);
  const keywordCheck = (e) => {
    setKeyword(e.currentTarget.value);
  };

  // 1. 유저가 선택한 필터링 카테고리 목록
  const selectedProfessorQuestionFilterCategory = useRecoilValue(
    selectedProfessorQuestionFilterMenuAtom,
  );

  // 2. 서버에서 받아온 페이징 정보를 전역 상태에 저장
  const [professorQuestionPageInfo, setProfessorQuestionPageInfo] = useRecoilState(
    professorQuestionPageInfoAtom,
  );
  const { refetch: professorQuestionPageInfoRefetch } = useQuery(
    ['getProfessorQnaPageInfo', ProfessorId, selectedProfessorQuestionFilterCategory],
    () =>
      getProfessorQnaPageInfo(
        ProfessorId,
        String([...selectedProfessorQuestionFilterCategory]).replace(/,/g, ' '),
        keyword,
      ),
    {
      retry: 0,
      onSuccess: (data) => {
        setProfessorQuestionPageInfo(data.data.total);
        if (isSearchBtnClicked) {
          setIsSearchBtnClicked(false);
        }
      },
      onError: (error) => {
        handleError(error);
      },
    },
  );

  useEffect(() => {
    professorQuestionPageInfoRefetch();
    setCurrentPage(1);
  }, [isSearchBtnClicked]);

  // 3. 서버에서 받아온 실제 데이터를 전역 상태에 저장
  const [professorQuestionList, setProfessorQuestionList] =
    useRecoilState(professorQuestionListAtom);
  const { refetch: professorQuestionListRefetch } = useQuery(
    ['getProfessorQnaList', ProfessorId, selectedProfessorQuestionFilterCategory, currentPage],
    () =>
      getProfessorQnaList(
        ProfessorId,
        String([...selectedProfessorQuestionFilterCategory]).replace(/,/g, ' '),
        keyword,
        currentPage,
      ),
    {
      retry: 0,
      enabled: false,
      onSuccess: (data) => {
        setProfessorQuestionList(data.data.qnaList);
      },
      onError: (error) => {
        handleError(error);
      },
    },
  );

  useEffect(() => {
    professorQuestionListRefetch();
  }, [selectedProfessorQuestionFilterCategory, isSearchBtnClicked, currentPage, navigate]);

  // 상세페이지 -> 이전페이지로 이동해도 페이지 유지
  useEffect(() => {
    if (navigate) {
      setCurrentPage(currentPage);
    }
  }, [navigate]);

  return (
    <>
      {id ? (
        <QuestionDetailPage />
      ) : (
        <QuestionContainer>
          <TabTitle>학습 질문</TabTitle>
          <Line />
          <ButtonContainer>
            {isLogin === true ? (
              <Button
                width={124}
                height={48}
                onClickFunc={() =>
                  (navigate(`/lecture/${professorId}/questionCreate`))
                }
              >
                글쓰기
              </Button>
            ) : (
              ''
            )}
          </ButtonContainer>
          <ButtonBox>
            <Filter
              filterMenu={FILTER_MENU}
              filterName={'카테고리'}
              filterLocation={'교수 학습질문'}
              setCurrentPage={setCurrentPage}
            />
            <Search keywordCheck={keywordCheck} setIsSearchBtnClicked={setIsSearchBtnClicked} />
          </ButtonBox>
          <QuestionTable>
            {professorQuestionList !== undefined ? (
              professorQuestionList.length < 1 ? (
                <DataNotFound>
                  <p>게시글이 존재하지 않습니다!</p>
                </DataNotFound>
              ) : (
                <>
                  {professorQuestionList.map((data) => (
                    <QuestionContent
                      key={data.id}
                      onClick={() =>
                        (navigate(`/lecture/${professorId}/question/${data.id}`))
                      }
                    >
                      <div>{data.id}</div>
                      <div>
                        <p>{useChangeMonthNumToEn(data.createdAt.slice(5, 7))}</p>
                        <p>{data.createdAt.slice(8, 10)}</p>
                        <p>{data.createdAt.slice(0, 4)}</p>
                      </div>
                      <div>
                        {data.category === 'LECTURE' ? (
                          <p>강의</p>
                        ) : data.category === 'BOOK' ? (
                          <p>교재</p>
                        ) : data.category === 'CURRICULUM' ? (
                          <p>커리큘럼</p>
                        ) : data.category === 'ETC' ? (
                          <p>기타</p>
                        ) : (
                          ''
                        )}
                        <p>{data.title}</p>
                      </div>
                      <div className={data.status === '답변 완료' ? 'complete' : ''}>
                        {data.status}
                      </div>
                      <div>
                        <p>작성자</p>
                        <p>{data.name}</p>
                      </div>
                    </QuestionContent>
                  ))}
                </>
              )
            ) : (
              <SpinLoader type={typeList[2].prop} color={'#000'} width={1311} height={715} />
            )}
          </QuestionTable>
          <PaginationBox>
            <PrevBtn
              className="prev-btn"
              onClick={(e) => {
                if (currentPage === 1) {
                  e.preventDefault();
                } else {
                  clickPrevBtn();
                }
              }}
            />
            <Pagination
              currentPage={currentPage}
              postsPerPage={postsPerPage}
              totalPosts={professorQuestionPageInfo}
              paginate={setCurrentPage}
            />
            <NextBtn
              className="next-btn"
              onClick={(e) => {
                if (currentPage === Math.ceil(professorQuestionPageInfo / postsPerPage)) {
                  e.preventDefault();
                } else {
                  clickNextBtn();
                }
              }}
            />
          </PaginationBox>
        </QuestionContainer>
      )}
    </>
  );
};

export default Question;
